var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: _vm.bemBlockMod({
        fixed: _vm.isFixed,
        secondary: _vm.isSecondaryLevel,
        "with-separator": _vm.hasSeparatorBefore,
        "with-separator-after": _vm.hasSeparatorAfter
      }),
      style: _vm.cssCustomProps
    },
    [
      _vm.shouldNavigate
        ? _c(
            "a",
            {
              class: [
                _vm.bemElement("link", {
                  secondary: _vm.isSecondaryLevel,
                  "with-separator": _vm.hasSeparatorBefore,
                  "with-separator-after": _vm.hasSeparatorAfter
                })
              ],
              attrs: { href: _vm.href },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.handleClick($event)
                }
              }
            },
            [_vm._t("default")],
            2
          )
        : _c(
            "button",
            {
              class: [
                _vm.bemElement("link", {
                  secondary: _vm.isSecondaryLevel,
                  "with-separator": _vm.hasSeparatorBefore
                }),
                "u-btn-clean"
              ],
              on: { click: _vm.handleClick }
            },
            [_vm._t("default")],
            2
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }